//LOCAL_POINTS
export const RESET_LOCAL_POINTS = "resetpoints";
export const UPDATE_LOCAL_POINTS = "updatepoints";
